<script>
export default {
  name: 'SolarPathEffect'
}
</script>

<style>
.app-centered-column__container:after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 0;
  background-image: url("/static/solar_path/Empty@3x.png");
  background-repeat: repeat-x;
  background-size: 96.25rem 29.13rem;
  background-position-y: 4.44rem;
  background-position-x: -26.94rem;
  opacity: 0.15;
}
</style>
